import { request } from "@/utils/response";
/**
 * 获取附件简历列表
 */
export const getResumeFiles = () => {
    return request(`/v1/user/resumeFiles`, {
        method: "POST",
    });
};
/**
 * 编辑简历名称
 * @param fileGroupId 简历分组ID
 * @param fileName 简历名称
 */
export const renameResume = (params) => {
    return request(`/v1/user/resumeFileRename`, {
        method: "POST",
        data: params,
    });
};
/**
 * 删除附件简历
 * @param fileGroupId 简历分组ID
 */
export const deleteResume = (fileGroupId) => {
    return request(`/v1/user/resumeFileDelete`, {
        method: "POST",
        data: { fileGroupId },
    });
};
/**
 * 设置默认简历
 * @param fileGroupId 简历分组ID
 */
export const setDefaultResume = (fileGroupId) => {
    return request(`/v1/user/resumeFileOpen`, {
        method: "POST",
        data: { fileGroupId },
    });
};
